'use client'
import { ChevronUp } from 'lucide-react'
import * as React from 'react'

import { FooterSb } from '@/components/findex-connect/types/component-types-sb'

type FooterProps = {
  data: FooterSb
}

export const Footer: React.FC<FooterProps> = ({ data }) => {
  // Data
  if (!data) return null
  const { socials, copyrightText, legalText } = data

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <footer className="FOOTER-CONTAINER relative z-10 flex w-full items-center justify-center bg-[#1c1f23] py-10 max-md:px-0 md:px-5">
      <div className="FOOTER-INNER max-w-container p-gutter mx-auto flex w-full flex-col gap-10">
        <div className="FOOTER-HEADER flex justify-between max-sm:mb-20 max-sm:flex-col max-sm:gap-10 md:items-center">
          <nav className="SOCIAL-LINKS flex gap-5">
            {socials &&
              socials?.map(({ label, icon, url }) => (
                <a
                  key={label}
                  href={url}
                  className="SOCIAL-LINK tab-outline-primary flex max-w-8 cursor-pointer items-center gap-2 rounded-lg transition-all duration-300 ease-in-out hover:scale-110"
                  aria-label={label}
                  target="_blank"
                  rel="noreferrer"
                >
                  {icon.filename && (
                    <img
                      src={icon.filename}
                      alt={icon.alt || label || 'Social Icon'}
                      className="SOCIAL-ICON"
                    />
                  )}
                </a>
              ))}
          </nav>
          <button
            onClick={handleScrollToTop}
            className="BACK-TO-TOP group tab-outline-primary flex cursor-pointer items-center gap-3 transition-all duration-150 ease-in-out hover:scale-101"
            aria-label="Scroll back to top"
          >
            <div className="UP-ICON group-hover:border-primary-light flex size-11 content-center items-center justify-center border border-white/20 transition-all duration-150 ease-in-out group-hover:border-2">
              <ChevronUp
                className="group-hover:text-primary-light scale-110 text-white transition-all duration-150 ease-in-out"
                strokeWidth={1}
                width={30}
              />
            </div>
            <span className="md:text-md group-hover:text-primary-light text-sm text-white transition-all duration-150 ease-in-out">
              Back to top
            </span>
          </button>
        </div>
        <div className="LEGAL-CONTENT flex flex-col gap-4 text-white">
          {copyrightText && <p className="text-sm">{copyrightText}</p>}

          {legalText &&
            legalText?.map((piece, index) => (
              <p key={index} className="text-sm">
                {piece.text}
              </p>
            ))}
        </div>
      </div>
    </footer>
  )
}
